import { asyncToGenerator as _asyncToGenerator } from './_virtual/_rollupPluginBabelHelpers.js';
import runtime_1 from './node_modules/regenerator-runtime/runtime.esm.js';
import 'cross-fetch/polyfill';

function fetchPrivate(_x, _x2) {
  return _fetchPrivate.apply(this, arguments);
}

function _fetchPrivate() {
  _fetchPrivate = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(input, init) {
    var defaultFetchOpts, fetchOpts, fetchResult;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            defaultFetchOpts = {
              referrer: 'no-referrer',
              referrerPolicy: 'no-referrer'
            };
            fetchOpts = Object.assign(defaultFetchOpts, init);
            _context.next = 4;
            return fetch(input, fetchOpts);

          case 4:
            fetchResult = _context.sent;
            return _context.abrupt("return", fetchResult);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchPrivate.apply(this, arguments);
}

export { fetchPrivate };
//# sourceMappingURL=fetchUtil.esm.js.map
